import { __ } from '@wordpress/i18n'

export default { notFound: __('No Media Downloads', 'dhsv_theme') }
